export default __webpack_public_path__ + "30d12af186e1f37ff9d0babfffd1b5c2.png";